import * as THREE from 'three';
import TWEEN from 'tween.js';

export default class Runner {
  constructor (state, renderer) {
    this.currentState = state;
    this.renderer = renderer;
  }

  run () {
    requestAnimationFrame(this.frame.bind(this));
  }

  frame (t) {
    requestAnimationFrame(this.frame.bind(this));
    TWEEN.update(t);
    this.renderer.render(this.currentState, this.currentState.camera);
    this.currentState.update(t);

  }
}



// WEBPACK FOOTER //
// ./src/runner.js